// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"f9575d33","310":"4d9704ba","453":"670e15c7","605":"9c363147","672":"44e630e7","725":"bae7b66f","894":"f780f04e"}[chunkId] + ".chunk.js";
};